import BaseEntity from './BaseEntity';
import GhaInstallation from './GhaInstallation';
import Plan from './Plan';
export default class User extends BaseEntity {
    constructor(data) {
        super();
        this.avatar = null;
        this.bitbucketAvatar = null;
        this.displayName = null;
        this.email = null;
        this.experimentalFeatures = false;
        this.fetchedPullRequestsProgress = null;
        this.fetchedRepositoriesProgress = null;
        this.gitlabAvatar = null;
        this.gha = false;
        this.ghaInstallations = [];
        this.largestOrganization = null;
        this.newsletterEnabled = false;
        this.otherEmailsEnabled = false;
        this.plan = null;
        this.skipTaskOrganisationInvite = false;
        this.sourceCampaign = null;
        this.weeklyReportEnabled = false;
        if ('avatar' in data) {
            this.avatar = this.parseProperty(data, 'avatar');
        }
        this.bitbucketAvatar = this.parseProperty(data, 'bitbucketAvatar');
        this.displayName = this.parseProperty(data, 'displayName');
        if ('email' in data) {
            this.email = this.parseProperty(data, 'email');
        }
        if ('experimentalFeatures' in data) {
            this.experimentalFeatures = this.parseProperty(data, 'experimentalFeatures');
        }
        if ('fetchedPullRequestsProgress' in data) {
            this.fetchedPullRequestsProgress = this.parseProperty(data, 'fetchedPullRequestsProgress');
        }
        if ('fetchedRepositoriesProgress' in data) {
            this.fetchedRepositoriesProgress = this.parseProperty(data, 'fetchedRepositoriesProgress');
        }
        this.gitlabAvatar = this.parseProperty(data, 'gitlabAvatar');
        if ('gha' in data) {
            this.gha = this.parseProperty(data, 'gha');
        }
        if ('ghaInstallations' in data && Array.isArray(data.ghaInstallations) && data.ghaInstallations.length) {
            const ghaInstallations = this.parseProperty(data, 'ghaInstallations');
            this.ghaInstallations = ghaInstallations.map((ghaInstallation) => new GhaInstallation(ghaInstallation));
        }
        this.id = this.parseProperty(data, 'id');
        if ('largestOrganization' in data) {
            this.largestOrganization = this.parseProperty(data, 'largestOrganization');
        }
        if ('newsletterEnabled' in data) {
            this.newsletterEnabled = this.parseProperty(data, 'newsletterEnabled');
        }
        if ('otherEmailsEnabled' in data) {
            this.otherEmailsEnabled = this.parseProperty(data, 'otherEmailsEnabled');
        }
        if ('plan' in data && data.plan) {
            this.plan = new Plan(this.parseProperty(data, 'plan'));
        }
        this.skipTaskOrganisationInvite = this.parseProperty(data, 'skipTaskOrganisationInvite');
        if ('sourceCampaign' in data) {
            this.sourceCampaign = this.parseProperty(data, 'sourceCampaign');
        }
        this.timezoneId = this.parseProperty(data, 'timezoneId');
        this.username = this.parseProperty(data, 'username');
        this.vcs = this.parseProperty(data, 'vcs');
        if ('weeklyReportEnabled' in data) {
            this.weeklyReportEnabled = this.parseProperty(data, 'weeklyReportEnabled');
        }
    }
}
